import { parseQuery } from './utils';

let isDebug = true;

/**
 * debug < log < info < warn < error
 */
export enum LogLevel {
  debug,
  log,
  info,
  warn,
  error
}

export function isDebugMode() {
  return isDebug;
}
export function setDebugMode(_isDebug: boolean) {
  isDebug = _isDebug;
}
/**
 * 生产环境（isDebug = false）：大于该等级的Log日志会被上报
 */
export const PostLogLevel = LogLevel.log;

//queryString强制指定，该等级以上（包括）均会console
//log以上的才输出
export const forceLogLevelQuery: string = parseQuery(location.search)['_logLevel'] || 'log';

export const isDocs = ~location.host.indexOf('docs');

export const isEta = ~location.host.indexOf('qingque');

const isDocsOrEtaProd_ =
  location.host === 'docs.corp.kuaishou.com' ||
  location.host === 'docs.qingque.cn' ||
  location.host === 'docs2.qingque.cn';

//是协作文档线上
export function isDocsOrEtaProd() {
  return isDocsOrEtaProd_;
}
